/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';


@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fileDistNameUniqueGet()` */
  static readonly FileDistNameUniqueGetPath = '/file/dist/{nameUnique}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDistNameUniqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDistNameUniqueGet$Response(
    params: {
      nameUnique: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, FileService.FileDistNameUniqueGetPath, 'get');
    if (params) {
      rb.path('nameUnique', params.nameUnique, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileDistNameUniqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDistNameUniqueGet(
    params: {
      nameUnique: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.fileDistNameUniqueGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileQueryPkGet()` */
  static readonly FileQueryPkGetPath = '/file/query/{pk}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileQueryPkGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileQueryPkGet$Response(
    params: {
      pk: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, FileService.FileQueryPkGetPath, 'get');
    if (params) {
      rb.path('pk', params.pk, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileQueryPkGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileQueryPkGet(
    params: {
      pk: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.fileQueryPkGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `filePoFinalFileViewPoNumberFileNameGet()` */
  static readonly FilePoFinalFileViewPoNumberFileNameGetPath = '/file/POFinalFile/View/{poNumber}/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filePoFinalFileViewPoNumberFileNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filePoFinalFileViewPoNumberFileNameGet$Response(
    params: {
      poNumber: string;
      fileName: string;
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, FileService.FilePoFinalFileViewPoNumberFileNameGetPath, 'get');
    if (params) {
      rb.path('poNumber', params.poNumber, {});
      rb.path('fileName', params.fileName, {});
      rb.query('fkWorkGroupId', params.fkWorkGroupId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filePoFinalFileViewPoNumberFileNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filePoFinalFileViewPoNumberFileNameGet(
    params: {
      poNumber: string;
      fileName: string;
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.filePoFinalFileViewPoNumberFileNameGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `filePoFinalFileQueryGet()` */
  static readonly FilePoFinalFileQueryGetPath = '/file/POFinalFile/Query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filePoFinalFileQueryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filePoFinalFileQueryGet$Response(
    params?: {
      poNumber?: string;
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, FileService.FilePoFinalFileQueryGetPath, 'get');
    if (params) {
      rb.query('poNumber', params.poNumber, {});
      rb.query('fkWorkGroupId', params.fkWorkGroupId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filePoFinalFileQueryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filePoFinalFileQueryGet(
    params?: {
      poNumber?: string;
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.filePoFinalFileQueryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
